// extracted by mini-css-extract-plugin
module.exports = {"vWhite":"#fff","vInk":"#131313","ref-line-wrapper":"ReferenceLineLabel__ref-line-wrapper___E+277 cut-text__cut-text___UqCVS"};